<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<div>
					<el-input size="samll" placeholder="输入商品链接" v-model="goodsurl" style="margin-bottom: 20px;" clearable>
						<el-button slot="append" icon="el-icon-search" @click="search"></el-button>
					</el-input>
					<el-card shadow="hover" style="width: 100%;margin-bottom: 20px;">
						<div class="flex" style="flex-direction: row;">
							<el-image style="width: 120px; height: 120px"
								:src="'https://gw.alicdn.com/imgextra/'+blockData.itemUrl" :preview-src-list="['https://gw.alicdn.com/imgextra/'+blockData.itemUrl]"></el-image>
							<div class="flex"
								style="flex-direction: column;justify-content: space-between;margin-left: 20px;">
								<div style="font-size: 18px;font-weight: bold;">
									{{blockData.itemName}}
								</div>
								<div style="font-size: 14px;">
									商品ID{{'【'+goodscode+'】'}}
									下游成交件单价：{{blockData.payPriceRange[0].toFixed(2) + ' ~ ' + blockData.payPriceRange[1].toFixed(2)}}
								</div>
							</div>
						</div>
					</el-card>
					<el-card shadow="hover" style="width: 100%;margin-bottom: 20px;">
						<div style="width: 100%;height: 40px;">
							<el-radio-group size="mini" v-model="day" @change="dayChange" style="float: right;">
								<el-radio-button label="1d"></el-radio-button>
								<el-radio-button label="7d"></el-radio-button>
								<el-radio-button label="30d"></el-radio-button>
							</el-radio-group>
						</div>
						<el-row :gutter="20">
							<el-col :span="4">
								<div>
									<el-statistic group-separator="," :precision="0" title="搜索人气">
										<template slot="title">
											<div style="margin:10px 0;">
												<el-link type="primary"
													@click="fieldChange('searchUv','搜索人气')">搜索人气</el-link>
												<el-tooltip class="item" effect="dark" placement="top-start">
													<div slot="content"
														style="text-align: justify;max-width: 180px;line-height: 16px;">
														统计时间内，根据该行业搜索用户数进行指数化后的指数类指标。搜索指数越高，代表搜索人数越多</div>
													<i class="el-icon-question"
														style="margin-left: 10px;color: black;"></i>
												</el-tooltip>

											</div>
										</template>
										<template slot="formatter">
											<div style="margin-bottom: 4px;">{{blockData.searchUv}}</div>
											<div v-if="blockData.searchUvRatio.type=='up'"
												style="font-size: 14px;color: #F56C6C;">
												<span style="font-size: 12px;color: #909399;">较上周期</span> {{blockData.searchUvRatio.value }}
											</div>
											<div v-else style="font-size: 14px;color: #67C23A;">
												<span style="font-size: 12px;color: #909399;">较上周期</span> {{blockData.searchUvRatio.value }}
											</div>
										</template>
									</el-statistic>
								</div>
							</el-col>
							<el-col :span="4">
								<div>
									<el-statistic group-separator="," :precision="0" title="搜索热度">
										<template slot="title">
											<div style="margin:10px 0;">
												<el-link type="primary"
													@click="fieldChange('searchPv','搜索热度')">搜索热度</el-link>
												<el-tooltip class="item" effect="dark" placement="top-start">
													<div slot="content"
														style="text-align: justify;max-width: 180px;line-height: 16px;">
														下游消费者搜索量参考，数值越大说明搜索的人越多</div>
													<i class="el-icon-question"
														style="margin-left: 10px;color: black;"></i>
												</el-tooltip>
											</div>
										</template>
										<template slot="formatter">
											<div style="margin-bottom: 4px;">{{blockData.searchPv}}</div>
											<div v-if="blockData.searchPvRatio.type=='up'"
												style="font-size: 14px;color: #F56C6C;">
												<span style="font-size: 12px;color: #909399;">较上周期</span> {{blockData.searchPvRatio.value }}
											</div>
											<div v-else style="font-size: 14px;color: #67C23A;">
												<span style="font-size: 12px;color: #909399;">较上周期</span> {{blockData.searchPvRatio.value }}
											</div>
										</template>
									</el-statistic>
								</div>
							</el-col>
							<el-col :span="4">
								<div>
									<el-statistic group-separator="," :precision="0" title="点击人气">
										<template slot="title">
											<div style="margin:10px 0;">
												<el-link type="primary"
													@click="fieldChange('clickUv','点击人气')">点击人气</el-link>

												<el-tooltip class="item" effect="dark" placement="top-start">
													<div slot="content"
														style="text-align: justify;max-width: 180px;line-height: 16px;">
														统计周期内，通过搜索引导至该行业下商品详情页的访客数进行指数化后的指标</div>
													<i class="el-icon-question"
														style="margin-left: 10px;color: black;"></i>
												</el-tooltip>
											</div>
										</template>
										<template slot="formatter">
											<div style="margin-bottom: 4px;">{{blockData.clickUv}}</div>
											<div v-if="blockData.clickUvRatio.type=='up'"
												style="font-size: 14px;color: #F56C6C;">
												<span style="font-size: 12px;color: #909399;">较上周期</span> {{blockData.clickUvRatio.value }}
											</div>
											<div v-else style="font-size: 14px;color: #67C23A;">
												<span style="font-size: 12px;color: #909399;">较上周期</span> {{blockData.clickUvRatio.value }}
											</div>
										</template>
									</el-statistic>
								</div>
							</el-col>
							<el-col :span="4">
								<div>
									<el-statistic group-separator="," :precision="0" title="点击热度">
										<template slot="title">
											<div style="margin:10px 0;">
												<el-link type="primary"
													@click="fieldChange('clickPv','点击热度')">点击热度</el-link>

												<el-tooltip class="item" effect="dark" placement="top-start">
													<div slot="content"
														style="text-align: justify;max-width: 180px;line-height: 16px;">
														下游消费者点击量参考，数值越大说明有意愿成交的人越多</div>
													<i class="el-icon-question"
														style="margin-left: 10px;color: black;"></i>
												</el-tooltip>
											</div>
										</template>
										<template slot="formatter">
											<div style="margin-bottom: 4px;">{{blockData.clickPv}}</div>
											<div v-if="blockData.clickPvRatio.type=='up'"
												style="font-size: 14px;color: #F56C6C;">
												<span style="font-size: 12px;color: #909399;">较上周期</span> {{blockData.clickPvRatio.value }}
											</div>
											<div v-else style="font-size: 14px;color: #67C23A;">
												<span style="font-size: 12px;color: #909399;">较上周期</span> {{blockData.clickPvRatio.value }}
											</div>
										</template>
									</el-statistic>
								</div>
							</el-col>
							<el-col :span="4">
								<div>
									<el-statistic group-separator="," :precision="0" title="点击率">
										<template slot="title">
											<div style="margin:10px 0;">

												<el-link type="primary"
													@click="fieldChange('searchAndPayRatio','点击率')">点击率</el-link>
												<el-tooltip class="item" effect="dark" placement="top-start">
													<div slot="content"
														style="text-align: justify;max-width: 180px;line-height: 16px;">
														统计时间内，点击人数/搜索用户数的比例</div>
													<i class="el-icon-question"
														style="margin-left: 10px;color: black;"></i>
												</el-tooltip>
											</div>
										</template>
										<template slot="formatter">
											<div style="margin-bottom: 4px;">
												{{(blockData.clickAndSearchRate * 100).toFixed(2)}}%
											</div>
											<div v-if="blockData.searchAndPayRatio.type=='up'"
												style="font-size: 14px;color: #F56C6C;">
												<span style="font-size: 12px;color: #909399;">较上周期</span> {{blockData.searchAndPayRatio.value }}
											</div>
											<div v-else style="font-size: 14px;color: #67C23A;">
												<span style="font-size: 12px;color: #909399;">较上周期</span> {{blockData.searchAndPayRatio.value }}
											</div>
										</template>
									</el-statistic>
								</div>
							</el-col>
							<el-col :span="4">
								<div>
									<el-statistic group-separator="," :precision="0" title="交易金额">
										<template slot="title">
											<div style="margin:10px 0;">

												<el-link type="primary"
													@click="fieldChange('tradePoint','交易金额')">交易金额</el-link>
												<el-tooltip class="item" effect="dark" placement="top-start">
													<div slot="content"
														style="text-align: justify;max-width: 180px;line-height: 16px;">
														统计时间内，根据产品交易过程中的核心指标如订单数、买家数、支付件数、支付金额等，进行综合计算得出的数值，不等同于交易金额
													</div>
													<i class="el-icon-question"
														style="margin-left: 10px;color: black;"></i>
												</el-tooltip>
											</div>
										</template>
										<template slot="formatter">
											<div style="margin-bottom: 4px;">{{blockData.tradePoint}}</div>
											<div v-if="blockData.tradePointRatio.type=='up'"
												style="font-size: 14px;color: #F56C6C;">
												<span style="font-size: 12px;color: #909399;">较上周期</span> {{blockData.tradePointRatio.value }}
											</div>
											<div v-else style="font-size: 14px;color: #67C23A;">
												<span style="font-size: 12px;color: #909399;">较上周期</span> {{blockData.tradePointRatio.value }}
											</div>
										</template>
									</el-statistic>
								</div>
							</el-col>
							<el-col :span="4">
								<div>
									<el-statistic group-separator="," :precision="0" title="支付转化率">
										<template slot="title">
											<div style="margin:10px 0;">

												<el-link type="primary"
													@click="fieldChange('searchAndPayRatio','支付转化率')">支付转化率</el-link>
												<el-tooltip class="item" effect="dark" placement="top-start">
													<div slot="content"
														style="text-align: justify;max-width: 180px;line-height: 16px;">
														统计时间内，所有终端的支付买家数/访客数的比例</div>
													<i class="el-icon-question"
														style="margin-left: 10px;color: black;"></i>
												</el-tooltip>
											</div>
										</template>
										<template slot="formatter">
											<div style="margin-bottom: 4px;">
												{{(blockData.searchAndPayRate * 100).toFixed(2)}}
											</div>
											<div v-if="blockData.searchAndPayRatio.type=='up'"
												style="font-size: 14px;color: #F56C6C;">
												<span style="font-size: 12px;color: #909399;">较上周期</span> {{blockData.searchAndPayRatio.value }}
											</div>
											<div v-else style="font-size: 14px;color: #67C23A;">
												<span style="font-size: 12px;color: #909399;">较上周期</span> {{blockData.searchAndPayRatio.value }}
											</div>
										</template>
									</el-statistic>
								</div>
							</el-col>
							<el-col :span="4">
								<div>
									<el-statistic group-separator="," :precision="0" title="商品指数">
										<template slot="title">
											<div style="margin:10px 0;">

												<el-link type="primary"
													@click="fieldChange('offerPoint','商品指数')">商品指数</el-link>
												<el-tooltip class="item" effect="dark" placement="top-start">
													<div slot="content"
														style="text-align: justify;max-width: 180px;line-height: 16px;">
														根据统计周期最后一天行业下全站有效商品相关指标综合计算得出，指数越高，表示有效商品数据越多</div>
													<i class="el-icon-question"
														style="margin-left: 10px;color: black;"></i>
												</el-tooltip>
											</div>
										</template>
										<template slot="formatter">
											<div style="margin-bottom: 4px;">{{blockData.offerPoint}}</div>
											<div v-if="blockData.offerPointRatio.type=='up'"
												style="font-size: 14px;color: #F56C6C;">
												<span style="font-size: 12px;color: #909399;">较上周期</span> {{blockData.offerPointRatio.value }}
											</div>
											<div v-else style="font-size: 14px;color: #67C23A;">
												<span style="font-size: 12px;color: #909399;">较上周期</span> {{blockData.offerPointRatio.value }}
											</div>
										</template>
									</el-statistic>
								</div>
							</el-col>
							<el-col :span="4">
								<div>
									<el-statistic group-separator="," :precision="0" title="飙升热度">
										<template slot="title">
											<div style="margin:10px 0;">

												<el-link type="primary"
													@click="fieldChange('soarPoint','飙升热度')">飙升热度</el-link>
												<el-tooltip class="item" effect="dark" placement="top-start">
													<div slot="content"
														style="text-align: justify;max-width: 180px;line-height: 16px;">
														搜索热度环比</div>
													<i class="el-icon-question"
														style="margin-left: 10px;color: black;"></i>
												</el-tooltip>
											</div>
										</template>
										<template slot="formatter">
											<div style="margin-bottom: 4px;">{{(blockData.soarPoint * 100).toFixed(2)}}%
											</div>
											<div style="font-size: 14px;">
												{{0}}
											</div>
										</template>
									</el-statistic>
								</div>
							</el-col>
						</el-row>
					</el-card>

					<el-card shadow="hover" style="width: 100%;margin-bottom: 20px;">
						<div style="height: 400px;">
							<div style="height: 90%;" id="competitiveChart"></div>
						</div>
					</el-card>
				</div>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import * as echarts from 'echarts';
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			currentrow: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_model: false,
				modal_title: '竞品透视',
				modal_width: 1000,
				modal_height: 800,
				goodsurl: null,
				blockData: {
					clickAndSearchRate: 0,
					clickAndSearchRateRatio: 0,
					clickPv: 0,
					clickPvRatio: 0,
					clickUv: 0,
					clickUvRatio: 0,
					itemName: '',
					itemUrl: 0,
					offerPoint: 0,
					offerPointRatio: 0,
					payPriceRange: [0, 0],
					searchAndPayRate: 0,
					searchAndPayRatio: 0,
					searchPv: 0,
					searchPvRatio: 0,
					searchUv: 0,
					searchUvRatio: 0,
					soarPoint: 0,
					tradePoint: 0,
					tradePointRatio: 0,
				},
				flowData: [],
				chart: null,
				day: '7d',
				goodscode: '635755541429'
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			dayChange() {
				this.init()
			},
			modal_init() {
				this.init()
			},
			search() {
				if (!this.goodsurl) {
					this.$message.error('请输入商品链接')
					return
				}
				let queryParams = new URLSearchParams(new URL(this.goodsurl).search)
				if (!queryParams.get('id')) {
					this.$message.error('商品ID获取失败')
					return
				}
				this.goodscode = queryParams.get('id')
				this.init()

			},
			init() {
				this.$api.BIshopgoods.buyerAdvisorOppDetailService({
					day: this.day,
					goodscode: this.goodscode,
				}).then((res) => {
					console.log(res.data.data)
					if (!res.data.data) {
						for (let i in this.blockData) {
							this.blockData[i] = 0
						}
						this.$message.error('暂无信息')
						return
					}
					for (let i in res.data.data) {
						if (i != 'itemName' && i != 'itemUrl' && i != 'payPriceRange') {
							this.blockData[i] = parseFloat(res.data.data[i])
						} else {
							this.blockData[i] = res.data.data[i]
						}
						if (i == 'payPriceRange') {
							this.blockData[i] = JSON.parse(res.data.data[i])
						}
						if (i.endsWith('Ratio')) {
							this.blockData[i] = this.ratioFommater(res.data.data[i])
						}

					}
					console.log(this.blockData)
				})
				this.$api.BIshopgoods.buyerAdvisorOppRangeService({
					goodscode: this.goodscode,
				}).then((res) => {
					this.flowData = res.data.data
					this.statisticsChart({
						field: 'tradePoint',
						title: '交易金额',
					})
					//console.log(this.flowData)
				})
			},
			ratioFommater(value) {
				if (value > 0) {
					return {
						value: (value * 100).toFixed(2) + '% ↑',
						type: 'up'
					}
				} else {
					return {
						value: (value * 100).toFixed(2) + '% ↓',
						type: 'down'
					}
				}

			},
			submit() {
				1
				//this.init()
			},
			reset() {
				//this.init()
			},
			fieldChange(field, title) {
				this.statisticsChart({
					field: field,
					title: title,
				})
			},
			statisticsChart(columns) {
				let data = JSON.parse(JSON.stringify(this.flowData))
				// let dataindex = 0
				let xarr = []
				let series = []
				let seriesdata = []

				data = this.$Lodash.groupBy(data, 'bizDate')

				for (let i in data) {
					let value = data[i][0][columns.field]
					xarr.push(i)
					seriesdata.push(value)
					//dataindex++
				}

				series.push({
					name: columns.title,
					type: 'line',
					// label: {
					// 	show: true,
					// 	position: 'top'
					// },
					emphasis: {
						focus: 'series'
					},
					data: seriesdata
				})
				console.log(series)
				if (this.chart) {
					this.chart.clear()
				} else {
					this.chart = echarts.init(document.getElementById('competitiveChart'))
				}
				this.chart.setOption({
					title: {
						text: columns.title,
						textStyle: {
							fontSize: 14
						}
					},
					legend: {
						data: []
					},
					grid: {
						left: '2%',
						right: '2%',
						bottom: '2%',
						containLabel: true
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						},
						// formatter: function(params) {
						// 	let markPointData = series[params[0]['seriesIndex']]['markPoint']['data']

						// 	let exist = markPointData.filter((item) => {
						// 		return item.dataindex == params[0]['dataIndex']
						// 	})
						// 	let resData =
						// 		`${xarr[params[0]['dataIndex']]}<br />${columns.title}：${params[0].data}`
						// 	exist.forEach((item) => {
						// 		resData += `<br />${item.content}`
						// 	})
						// 	return resData
						// }
					},
					toolbox: {
						show: true,
						orient: 'vertical',
						left: 'right',
						top: 'center',
						feature: {
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: false
							},
							magicType: {
								show: true,
								type: ['line', 'bar', 'stack']
							},
							restore: {
								show: false
							},
							saveAsImage: {
								show: true
							}
						}
					},
					xAxis: {
						data: xarr
					},
					yAxis: {},
					series: series
				})


				//console.log(xarr,this.tableData)

			},
			modal_onhide(){
				this.chart = null
			}
		},
		components: {

		}
	}
</script>